import classnames from "classnames";
import { withGenericConfig } from "contexts/generic-config-context";
import ExpandArrow from "static/svg/header/expand_arrow_1.svg";
import ArrowRight from "static/svg/arrow-right.svg";
import { componentStyles } from "./structured-header-menu-left-panel.scss";
import HeaderMenuSectionItemComponent from "../../sections-header-menu/header-menu-section-item/header-menu-section-item-component";

const StructuredHeaderMenuLeftPanelComponent = (props) => {
  const { menu, innerMenuIndex, setInnerMenuIndex, innerMenuSubIndex, setInnerMenuSubIndex, translate, hasSubItems } =
    props;
  const { bottomItem } = menu;

  const onItemClick = ({ itemIndex }) => {
    setInnerMenuIndex(itemIndex);

    if (hasSubItems(itemIndex)) {
      setInnerMenuSubIndex(0);
    }
  };

  const onSubItemClick = ({ itemIndex, subItemIndex }) => {
    // TODO: fire BigBrain event
  };

  const onSubItemHover = ({ itemIndex, subItemIndex }) => {
    setInnerMenuIndex(itemIndex);
    setInnerMenuSubIndex(subItemIndex);
  };

  const renderSubItem = ({ itemIndex, subItem, subItemIndex }) => {
    const { icon, title } = subItem;
    const Icon = icon;
    return (
      <div
        className={classnames("inner-menu-item-subitem", {
          selected: itemIndex === innerMenuIndex && subItemIndex === innerMenuSubIndex
        })}
        onClick={() => {
          onSubItemClick({ itemIndex, subItemIndex });
        }}
        onMouseEnter={() => {
          onSubItemHover({ itemIndex, subItemIndex });
        }}
      >
        <div className="inner-menu-item-subitem-title-and-icon">
          {icon && <Icon className={classnames("inner-menu-item-subitem-title-icon")} />}
          <span>{translate(title)}</span>
        </div>
        <div className="inner-menu-item-subitem-title-arrow">
          <ArrowRight className="arrow-icon" />
        </div>
      </div>
    );
  };

  const renderItem = ({ item, itemIndex }) => {
    const isItemSelected = itemIndex === innerMenuIndex;
    return (
      <div className={classnames("inner-menu-item", { selected: isItemSelected })}>
        <div className="inner-menu-item-title" onClick={() => onItemClick({ itemIndex })}>
          {translate(item?.title)}
          <ExpandArrow
            className={classnames("expand-arrow", { "down-direction": isItemSelected && hasSubItems(itemIndex) })}
          />
        </div>
        {hasSubItems(itemIndex) && (
          <div className={classnames("inner-menu-item-subitems")}>
            {item.subItems.map((subItem, subItemIndex) => renderSubItem({ itemIndex, subItem, subItemIndex }))}
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="structured-header-menu-left-panel">
      <div className="structured-header-menu-left-panel-items">{menu.items.map((item, itemIndex) => renderItem({ item, itemIndex }))}</div>
      <div>{bottomItem && <HeaderMenuSectionItemComponent {...bottomItem} /* menuId={menuId} sectionId={id} */ />}</div>
      <style jsx>{componentStyles}</style>
    </div>
  );
};

export default withGenericConfig(StructuredHeaderMenuLeftPanelComponent);
